import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SealinesPipe } from './sealines.pipe';

@NgModule({
    imports: [CommonModule, SealinesPipe],
    declarations: [],
    exports: [],
})
export class SealinesModule { }
